import React from 'react';
import sporting_life from '../../assests/img/sporting-life.jpg';

const SportingLife = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Sporting Life</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Sporting Life
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={sporting_life} alt="sporting-life" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Sport is one of the key components of life at KCMS, and we aim to give all pupils the chance to benefit from learning through sport by playing and being taught the sport of their choice. The sports programme serves to reinforce many of the traits and values we believe are important, including: commitment, honesty, leadership, resilience, respect, responsibility, self-discipline and teamwork. We aspire to provide a wealth of sports from which pupils of all abilities are free to choose, and all pupils are encouraged to adopt and maintain an active, healthy lifestyle. The safety and welfare of the pupils is our top priority at all times. The programme is designed and resourced to be fully inclusive, catering for the needs and enjoyment of all pupils, from the interested novice to the elite performer. All pupils are encouraged to maximise the realisation of their potential for growth physically, mentally, socially and emotionally, to develop character in a broad sense.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    KCMS aims to build a strong reputation for sport. Pupils participating in sport will be expected to commit to playing for the school, with fixtures taking place regularly on weekends but also on weekdays (depending on the sport). Pupils will represent the school not only in inter-school fixtures, but individuals and teams will be encouraged and supported to regularly participate in district, state and national competitions.
                                                </p>

                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default SportingLife;